export const ADMIN_LEVELS: readonly string[] = ['MOD', 'ADMIN', 'DEV', 'OWNER'];
